"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDashboardPlugin = exports.convertScheduledMail = exports.convertScheduledMailAttachment = exports.convertWidgetAlert = exports.convertDashboard = exports.convertPluginLink = exports.convertWidget = exports.convertDrill = exports.convertFilterContext = exports.convertFilterContextItem = exports.convertLayoutItemSize = exports.convertLayoutSize = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var ReferenceConverter_1 = require("../fromBackend/ReferenceConverter");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
var PropertiesConverter_1 = require("../fromBackend/PropertiesConverter");
var refToUri = function (ref) {
    ts_invariant_1.default(sdk_model_1.isUriRef(ref));
    return ref.uri;
};
var refToIdentifier = function (ref) {
    ts_invariant_1.default(sdk_model_1.isIdentifierRef(ref));
    return ref.identifier;
};
var refToLocalId = function (ref) {
    ts_invariant_1.default(sdk_model_1.isLocalIdRef(ref));
    return ref.localIdentifier;
};
exports.convertLayoutSize = function (size) {
    var converted = {
        width: size.gridWidth,
    };
    if (size.gridHeight) {
        converted.height = size.gridHeight;
    }
    if (size.heightAsRatio) {
        converted.heightAsRatio = size.heightAsRatio;
    }
    return converted;
};
exports.convertLayoutItemSize = function (column) {
    var allScreens = ["xl", "md", "lg", "sm", "xs"];
    return allScreens.reduce(function (acc, el) {
        var _a;
        var size = column[el];
        if (size) {
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[el] = exports.convertLayoutSize(size), _a));
        }
        return acc;
    }, {});
};
var convertLayoutItem = function (column) {
    var size = column.size, widget = column.widget;
    if (sdk_backend_spi_1.isWidget(widget)) {
        return {
            size: exports.convertLayoutItemSize(size),
            content: {
                widget: { qualifier: { uri: refToUri(widget.ref) } },
            },
        };
    }
    else if (sdk_backend_spi_1.isDashboardLayout(widget)) {
        return {
            size: exports.convertLayoutItemSize(size),
            content: convertLayout(widget),
        };
    }
    else if (sdk_backend_spi_1.isWidgetDefinition(widget)) {
        // This should never happen -> widgets in the layout should be already saved
        throw new sdk_backend_spi_1.UnexpectedError("Cannot convert layout widget definition to bear model!");
    }
    return {
        size: exports.convertLayoutItemSize(size),
    };
};
var convertLayoutSection = function (section) {
    var _a, _b;
    var convertedRow = {
        columns: section.items.map(function (column) { return convertLayoutItem(column); }),
    };
    if (section.header) {
        // Ignore empty strings in header
        var headerWithoutEmptyStrings = omitBy_1.default(section.header, function (x) { return !x; });
        var isEmptyHeader = isEmpty_1.default(headerWithoutEmptyStrings);
        if (!isEmptyHeader) {
            var header = {};
            if ((_a = section.header) === null || _a === void 0 ? void 0 : _a.title) {
                header.title = section.header.title;
            }
            if ((_b = section.header) === null || _b === void 0 ? void 0 : _b.description) {
                header.description = section.header.description;
            }
            convertedRow.header = header;
        }
    }
    return convertedRow;
};
var convertLayout = function (layout) {
    var sections = layout.sections;
    var convertedLayout = {
        fluidLayout: {
            rows: sections.map(convertLayoutSection),
        },
    };
    if (layout.size) {
        convertedLayout.fluidLayout.size = exports.convertLayoutSize(layout.size);
    }
    return convertedLayout;
};
exports.convertFilterContextItem = function (filterContextItem) {
    if (sdk_backend_spi_1.isDashboardDateFilter(filterContextItem)) {
        var _a = filterContextItem.dateFilter, granularity = _a.granularity, type = _a.type, attribute = _a.attribute, dataSet = _a.dataSet, from = _a.from, to = _a.to;
        var convertedDateFilter = {
            dateFilter: {
                granularity: granularity,
                type: type,
                from: from === null || from === void 0 ? void 0 : from.toString(),
                to: to === null || to === void 0 ? void 0 : to.toString(),
            },
        };
        if (attribute) {
            convertedDateFilter.dateFilter.attribute = refToUri(attribute);
        }
        if (dataSet) {
            convertedDateFilter.dateFilter.dataSet = refToUri(dataSet);
        }
        return convertedDateFilter;
    }
    var _b = filterContextItem.attributeFilter, attributeElements = _b.attributeElements, displayForm = _b.displayForm, negativeSelection = _b.negativeSelection, localIdentifier = _b.localIdentifier, _c = _b.filterElementsBy, filterElementsBy = _c === void 0 ? [] : _c;
    var displayFormUri = refToUri(displayForm);
    var convertedAttributeFilterParents = filterElementsBy.map(function (filterElementsByItem) {
        return {
            filterLocalIdentifier: filterElementsByItem.filterLocalIdentifier,
            over: {
                attributes: filterElementsByItem.over.attributes.map(refToUri),
            },
        };
    });
    if (sdk_model_1.isAttributeElementsByValue(attributeElements)) {
        throw new sdk_backend_spi_1.NotSupported("Bear backend does not support value attribute filters in analytical dashboards");
    }
    return {
        attributeFilter: {
            negativeSelection: negativeSelection,
            attributeElements: attributeElements.uris,
            displayForm: displayFormUri,
            localIdentifier: localIdentifier,
            filterElementsBy: convertedAttributeFilterParents,
        },
    };
};
function convertFilterContext(filterContext) {
    if (sdk_backend_spi_1.isTempFilterContext(filterContext)) {
        var created = filterContext.created, filters_1 = filterContext.filters;
        return {
            tempFilterContext: tslib_1.__assign({ created: created, filters: filters_1.map(exports.convertFilterContextItem) }, (filterContext
                ? {
                    uri: refToUri(filterContext.ref),
                }
                : {})),
        };
    }
    var description = filterContext.description, filters = filterContext.filters, title = filterContext.title;
    return {
        filterContext: {
            content: {
                filters: filters.map(exports.convertFilterContextItem),
            },
            meta: tslib_1.__assign({ summary: description, title: title }, (sdk_backend_spi_1.isFilterContext(filterContext)
                ? {
                    uri: refToUri(filterContext),
                    identifier: filterContext.identifier,
                }
                : {})),
        },
    };
}
exports.convertFilterContext = convertFilterContext;
var convertFilterReference = function (filterReference) {
    if (sdk_backend_spi_1.isDashboardDateFilterReference(filterReference)) {
        return {
            dateFilterReference: {
                dataSet: refToUri(filterReference.dataSet),
            },
        };
    }
    return {
        attributeFilterReference: {
            displayForm: refToUri(filterReference.displayForm),
        },
    };
};
function convertDrill(drill) {
    if (sdk_backend_spi_1.isDrillToLegacyDashboard(drill)) {
        var tab = drill.tab;
        return {
            projectDashboard: refToUri(drill.target),
            projectDashboardTab: tab,
        };
    }
    var origin = drill.origin;
    var drillFrom;
    if (sdk_backend_spi_1.isDrillFromMeasure(origin)) {
        var measure = origin.measure;
        drillFrom = {
            drillFromMeasure: {
                localIdentifier: refToLocalId(measure),
            },
        };
    }
    else if (sdk_backend_spi_1.isDrillFromAttribute(origin)) {
        var attribute = origin.attribute;
        drillFrom = {
            drillFromAttribute: {
                localIdentifier: refToLocalId(attribute),
            },
        };
    }
    else {
        throw new sdk_backend_spi_1.UnexpectedError("Unable to convert unknown drill origin!");
    }
    if (sdk_backend_spi_1.isDrillToDashboard(drill)) {
        return {
            drillToDashboard: {
                from: drillFrom,
                target: "in-place",
                toDashboard: drill.target !== undefined ? refToIdentifier(drill.target) : undefined,
            },
        };
    }
    else if (sdk_backend_spi_1.isDrillToInsight(drill)) {
        return {
            drillToVisualization: {
                from: drillFrom,
                target: "pop-up",
                toVisualization: {
                    uri: refToUri(drill.target),
                },
            },
        };
    }
    else if (sdk_backend_spi_1.isDrillToCustomUrl(drill)) {
        return {
            drillToCustomUrl: {
                from: drillFrom,
                target: "new-window",
                customUrl: drill.target.url,
            },
        };
    }
    else if (sdk_backend_spi_1.isDrillToAttributeUrl(drill)) {
        return {
            drillToAttributeUrl: {
                from: drillFrom,
                target: "new-window",
                drillToAttributeDisplayForm: { uri: refToUri(drill.target.hyperlinkDisplayForm) },
                insightAttributeDisplayForm: { uri: refToUri(drill.target.displayForm) },
            },
        };
    }
    throw new sdk_backend_spi_1.UnexpectedError("Unable to convert unknown drill!");
}
exports.convertDrill = convertDrill;
exports.convertWidget = function (widget) {
    var ignoreDashboardFilters = widget.ignoreDashboardFilters, dateDataSet = widget.dateDataSet, title = widget.title, description = widget.description, drills = widget.drills;
    var meta = tslib_1.__assign(tslib_1.__assign({}, (sdk_backend_spi_1.isWidget(widget)
        ? {
            identifier: widget.identifier,
            uri: refToUri(widget.ref),
        }
        : {})), { title: title, summary: description });
    var convertedDateDataSet = dateDataSet && refToUri(dateDataSet);
    var convertedIgnoredDashboardFilters = ignoreDashboardFilters.map(convertFilterReference);
    if (widget.type === "kpi") {
        ts_invariant_1.default(widget.kpi, "Widget type is kpi, but kpi props are not defined!");
        var kpi = widget.kpi;
        return {
            kpi: {
                content: tslib_1.__assign(tslib_1.__assign({}, (sdk_backend_spi_1.isLegacyKpiWithComparison(kpi)
                    ? {
                        comparisonDirection: kpi.comparisonDirection,
                        comparisonType: kpi.comparisonType,
                    }
                    : {
                        comparisonType: kpi.comparisonType,
                    })), { metric: refToUri(kpi.metric), ignoreDashboardFilters: convertedIgnoredDashboardFilters, dateDataSet: convertedDateDataSet, drillTo: drills.length > 0 ? convertDrill(drills[0]) : undefined }),
                meta: meta,
            },
        };
    }
    var insight = widget.insight, _a = widget.properties, widgetProperties = _a === void 0 ? {} : _a;
    var _b = ReferenceConverter_1.convertUrisToReferences({
        properties: widgetProperties,
        references: {},
    }), properties = _b.properties, references = _b.references;
    var nonEmptyProperties = omitBy_1.default(properties, function (value, key) { return key !== "controls" && isEmpty_1.default(value); });
    return {
        visualizationWidget: {
            content: tslib_1.__assign(tslib_1.__assign({ visualization: refToUri(insight), ignoreDashboardFilters: convertedIgnoredDashboardFilters, dateDataSet: convertedDateDataSet, drills: drills
                    ? drills.map(convertDrill)
                    : [] }, (!isEmpty_1.default(nonEmptyProperties) && {
                properties: PropertiesConverter_1.serializeProperties(nonEmptyProperties),
            })), (!isEmpty_1.default(references) && { references: references })),
            meta: meta,
        },
    };
};
var convertAbsoluteDateFilterPreset = function (preset) {
    var _ = preset.type, rest = tslib_1.__rest(preset, ["type"]);
    return rest;
};
var convertRelativeDateFilterPreset = function (preset) {
    var _ = preset.type, rest = tslib_1.__rest(preset, ["type"]);
    return rest;
};
var convertDateFilterConfig = function (config) {
    var _a, _b, _c, _d;
    var absolutePresets = (_b = (_a = config.addPresets) === null || _a === void 0 ? void 0 : _a.absolutePresets) === null || _b === void 0 ? void 0 : _b.map(convertAbsoluteDateFilterPreset);
    var relativePresets = (_d = (_c = config.addPresets) === null || _c === void 0 ? void 0 : _c.relativePresets) === null || _d === void 0 ? void 0 : _d.map(convertRelativeDateFilterPreset);
    var addPresets = absolutePresets || relativePresets
        ? tslib_1.__assign(tslib_1.__assign({}, (absolutePresets && { absolutePresets: absolutePresets })), (relativePresets && { relativePresets: relativePresets })) : undefined;
    return tslib_1.__assign(tslib_1.__assign({}, config), (addPresets && { addPresets: addPresets }));
};
exports.convertPluginLink = function (pluginLink) {
    var plugin = pluginLink.plugin, parameters = pluginLink.parameters;
    return {
        type: refToUri(plugin),
        parameters: parameters,
    };
};
exports.convertDashboard = function (dashboard) {
    var filterContext = dashboard.filterContext, layout = dashboard.layout, ref = dashboard.ref, identifier = dashboard.identifier, title = dashboard.title, description = dashboard.description, dateFilterConfig = dashboard.dateFilterConfig, isLocked = dashboard.isLocked, tags = dashboard.tags, plugins = dashboard.plugins, shareStatus = dashboard.shareStatus, isUnderStrictControl = dashboard.isUnderStrictControl;
    var convertedLayout = layout && convertLayout(layout);
    var widgets = layout && sdk_backend_spi_1.layoutWidgets(layout);
    var dashboardUri = ref && refToUri(ref);
    var filterContextUri = (filterContext === null || filterContext === void 0 ? void 0 : filterContext.ref) && refToUri(filterContext.ref);
    var convertedDateFilterConfig = dateFilterConfig && convertDateFilterConfig(dateFilterConfig);
    var convertedPlugins = plugins === null || plugins === void 0 ? void 0 : plugins.map(exports.convertPluginLink);
    var sharedWithSomeoneProp = shareStatus === "shared"
        ? {
            sharedWithSomeone: 1,
        }
        : {};
    var flagsProp = {};
    if (isUnderStrictControl !== undefined) {
        flagsProp = isUnderStrictControl
            ? {
                flags: ["strictAccessControl"],
            }
            : {
                flags: [],
            };
    }
    return {
        analyticalDashboard: {
            content: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (convertedDateFilterConfig && { dateFilterConfig: convertedDateFilterConfig })), (convertedPlugins && !isEmpty_1.default(convertedPlugins) && { plugins: convertedPlugins })), { filterContext: filterContextUri, widgets: widgets ? widgets.filter(sdk_backend_spi_1.isWidget).map(function (widget) { return refToUri(widget.ref); }) : [], layout: convertedLayout }),
            meta: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (dashboardUri
                ? {
                    uri: dashboardUri,
                    identifier: identifier,
                }
                : {})), { title: title, summary: description, locked: isLocked, tags: tags === null || tags === void 0 ? void 0 : tags.join(" "), unlisted: shareStatus === "public" ? 0 : 1 }), sharedWithSomeoneProp), flagsProp),
        },
    };
};
exports.convertWidgetAlert = function (alert) {
    var dashboard = alert.dashboard, widget = alert.widget, description = alert.description, isTriggered = alert.isTriggered, threshold = alert.threshold, title = alert.title, whenTriggered = alert.whenTriggered, ref = alert.ref, identifier = alert.identifier, filterContext = alert.filterContext;
    var alertUri = ref && refToUri(ref);
    return {
        kpiAlert: {
            content: {
                filterContext: (filterContext === null || filterContext === void 0 ? void 0 : filterContext.ref) && refToUri(filterContext.ref),
                dashboard: refToUri(dashboard),
                kpi: refToUri(widget),
                isTriggered: isTriggered,
                threshold: threshold,
                whenTriggered: whenTriggered,
            },
            meta: tslib_1.__assign(tslib_1.__assign({}, (alertUri
                ? {
                    uri: alertUri,
                    identifier: identifier,
                }
                : {})), { title: title, summary: description }),
        },
    };
};
exports.convertScheduledMailAttachment = function (scheduledMailAttachment) {
    var dashboard = scheduledMailAttachment.dashboard, format = scheduledMailAttachment.format, filterContext = scheduledMailAttachment.filterContext;
    return {
        kpiDashboardAttachment: {
            uri: refToUri(dashboard),
            format: format,
            filterContext: filterContext && refToUri(filterContext),
        },
    };
};
exports.convertScheduledMail = function (scheduledMail) {
    var title = scheduledMail.title, description = scheduledMail.description, uri = scheduledMail.uri, identifier = scheduledMail.identifier, body = scheduledMail.body, subject = scheduledMail.subject, to = scheduledMail.to, when = scheduledMail.when, bcc = scheduledMail.bcc, lastSuccessful = scheduledMail.lastSuccessful, unsubscribed = scheduledMail.unsubscribed, attachments = scheduledMail.attachments, unlisted = scheduledMail.unlisted;
    return {
        scheduledMail: {
            content: {
                attachments: attachments.map(exports.convertScheduledMailAttachment),
                body: body,
                subject: subject,
                to: to,
                when: {
                    startDate: when.startDate,
                    endDate: when.endDate,
                    timeZone: when.timeZone,
                    recurrency: when.recurrence,
                },
                bcc: bcc,
                lastSuccessfull: lastSuccessful,
                unsubscribed: unsubscribed,
            },
            meta: tslib_1.__assign(tslib_1.__assign({ unlisted: unlisted ? 1 : 0 }, (uri
                ? {
                    uri: uri,
                    identifier: identifier,
                }
                : {})), { title: title, summary: description }),
        },
    };
};
exports.convertDashboardPlugin = function (plugin) {
    var uri = plugin.uri, identifier = plugin.identifier, name = plugin.name, tags = plugin.tags, description = plugin.description, url = plugin.url;
    return {
        dashboardPlugin: {
            content: {
                url: url,
            },
            meta: tslib_1.__assign(tslib_1.__assign({}, (uri ? { uri: uri, identifier: identifier } : {})), { title: name, summary: description, tags: tags === null || tags === void 0 ? void 0 : tags.join(" ") }),
        },
    };
};
//# sourceMappingURL=DashboardConverter.js.map